export default __webpack_public_path__ + "static/media/property_924.9da2712a.png";